export default {
  props: {
    description: {
      type: String,
      default: ''
    },
    isDisplayDescriptionUnder: {
      type: Boolean,
      default: false
    }
  }
};
